import {api, request} from '../../lib/api.js'
const root = '/api/verification/artwork-receipts'
export const researchReceiptApi = {
  context: (jobId, opts = {}) => request(`${root}/context/${encodeURIComponent(jobId)}`, opts),
  history: (jobId, kind, opts = {}) => request(`${root}/${encodeURIComponent(jobId)}/${encodeURIComponent(kind)}`, opts),
  capture: body => request(`${root}/capture`, {method: 'POST', body}),
  captureBytes: (jobId, captureId, opts = {}) => request(`${root}/capture/${encodeURIComponent(jobId)}/${encodeURIComponent(captureId)}`, {...opts, responseType: 'blob'}),
  submit: body => request(`${root}/submit`, {method: 'POST', body}),
  review: body => request(`${root}/review`, {method: 'POST', body}),
  revoke: body => request(`${root}/revoke`, {method: 'POST', body}),
  // Preserve the FULL existing response, including companies/companiesError.
  freshAuthority: (championshipId, opts = {}) => api.championshipRecord(championshipId, opts),
}
